export default __webpack_public_path__ + "static/media/sjdsBg.c036aad3.png";